:host {
  display: block;
  background-color: var(--theme-secondary-background);
  padding: var(--spacer-6) var(--spacer-5);
  text-align: center;
  margin: var(--spacer-3) 0;
}

slot {
  font-size: calc(var(--default-font-size) + 2px);
  line-height: var(--default-line-height);
  color: var(--theme-accent-text);
}
